import { Component, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { VariablesGlobalesService } from './services/variables-globales.service';
import { EncriptarService } from './services/encriptar.service';
import { Device } from '@capacitor/device';
import { enumPerfilAcceso, enumSegmentTipoDocumento, enumTipoDocumento, enumTipoOperacion, eTipoFicheroTerceros, globalConf } from '../GlobalConf';
import { SwUpdate } from '@angular/service-worker'
import { FirebaseService } from './services/firebase-service.service';
import { localeEn, localeEs, localeCa, localeDe, localeFr, localeIt, localePtPT, localeUa } from '@mobiscroll/angular';
import { Network } from '@capacitor/network';
import { MeteoService } from './services/meteo.service';
import { VerificacionesService } from './services/verificaciones.service';
import { Geolocation } from '@capacitor/geolocation';
import { HttpClient } from '@angular/common/http';
import { GoogleCalendarService } from './services/googleCalendar.service';
import { DocumentoApp } from './Models/ApiV2/DocumentoDTO';
import { NgClass, TitleCasePipe } from '@angular/common';
import { db } from 'src/db/db';
import { Storage } from '@capacitor/storage';
import { Router, RouterModule } from '@angular/router';
import { HostListener } from "@angular/core";
import { TitleNombreApellidos } from './pipes/titleNombreApellidos.pipe';
import { BarraSuperiorComponent } from './components/barra-superior/barra-superior.component';
import { SelectorIdiomaComponent } from './components/selector-idioma/selector-idioma.component';
import { InterceptorService } from './services/interceptor/interceptor.service';
import { App, AppState } from '@capacitor/app';
import { ProcesosGlobalesService } from './services/procesos-globales.service';
import { SesionActual } from './Models/SesionActual';
import { addIcons } from 'ionicons';
import {
  IonApp, IonCol, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonList, IonMenu,
  IonMenuButton, IonMenuToggle, IonRouterOutlet, IonRow, IonSplitPane, IonTabButton,
  IonTabs, IonToolbar, IonLabel,
  IonText, Platform, ToastController,
  IonTabBar
} from '@ionic/angular/standalone';
import {
  homeOutline, cubeOutline, peopleOutline, personOutline, clipboardOutline, documentOutline, logInOutline,
  home, cube, people, person, clipboard, clipboardSharp, document, logIn,
  calendarOutline,
  calendar
} from 'ionicons/icons';


@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: 'app.component.html',
  styleUrls: [
    'app.component.scss',
    '../theme/estilosMenu/side-menu.scss',
    '../theme/estilosMenu/side-menu.shell.scss',
    '../theme/estilosMenu/side-menu.responsive.scss',
    '../theme/fonts.scss'
  ],
  imports: [NgClass, IonApp, IonSplitPane, IonMenu, IonHeader, IonRow, IonCol, IonToolbar, IonFooter, IonContent, IonList, IonMenuToggle,
    IonItem, IonRouterOutlet, IonTabs, IonTabButton, IonMenuButton, IonLabel, IonText, IonTabBar,
    TranslateModule, TitleCasePipe, TitleNombreApellidos, BarraSuperiorComponent, SelectorIdiomaComponent, RouterModule, IonIcon

  ]
})
export class AppComponent {
  variablesGlobales = inject(VariablesGlobalesService);
  private servicioEncriptar = inject(EncriptarService);
  firebaseService = inject(FirebaseService);
  private meteoService = inject(MeteoService);
  verificacionesSvc = inject(VerificacionesService);
  googleCalendarService = inject(GoogleCalendarService);
  interceptor = inject(InterceptorService);
  procesosGlobales = inject(ProcesosGlobalesService);

  paginas = globalConf.paginasMenu
  version = globalConf.app_version;
  enumPerfilAcceso;
  public themeLinkElement: HTMLLinkElement;
  private httpClient = inject(HttpClient);
  private translate = inject(TranslateService);
  public platform = inject(Platform);
  private swUpdate = inject(SwUpdate);
  public toastController = inject(ToastController);
  public router = inject(Router);

  /** Inserted by Angular inject() migration for backwards compatibility */
  //constructor(...args: unknown[]);

  constructor() {
    this.controlRefreshPage();
    this.onResize();
    this.enumPerfilAcceso = enumPerfilAcceso
    this.initializeApp();
    this.actualizarVersion()
    this.translate.addLangs(['ca-ES', 'de-DE', 'en-US', 'es-ES', 'eu-ES', 'fr-FR', 'gl-ES', 'it-IT', 'pt-PT', 'uk-UA']);
    this.translate.setDefaultLang('es-ES');
    this.variablesGlobales.idiomaSeleccionado = ('es-ES')
    this.cargarIdiomaStorage()
    this.obtenerPlataforma()
    this.controlarInternet();
    this.cargardocumentoActual()
    this.obtenerInfoMeteorologica();
    this.verificacionesSvc.comprobarDispositivoConInternet();
    console.log('Perfil Acceso: ', this.variablesGlobales.perfilAcceso);
    addIcons({
      homeOutline, cubeOutline, peopleOutline, personOutline, clipboardOutline, documentOutline, logInOutline, calendarOutline,
      home, cube, people, person, clipboard, clipboardSharp, document, logIn, calendar
    });
  }

  initializeApp() {
    this.platform.ready().then(() => {
      if (this.platform.is('ios') || this.platform.is('android')) {
        //window.screen.orientation.lock('portrait');
      }
      this.firebaseService.conectarRemoteConfig();
    });

    //this.servicioEncriptar.desencriptarAES('/lUqnJenJu/zNmN+6GMWzJ6BUR8Hqvl9g87kKpVoCSv7oiMex/u+5NuoPz0+cW1N', 'ef1a-4f51-b2e0-c')
    //this.servicioEncriptar.desencriptarAES('M4FG0zdsF+4daRHtq8KSnsKM8K3VNBkSN8G/Y/jx4OA=', 'ef1a-4f51-b2e0-c')
    //this.servicioEncriptar.encriptarAES_ALO('DE12100110012620508045','ef1a-4f51-b2e0-c')
  }
  controlRefreshPage() {
    const urlParams = new URLSearchParams(window.location.search);
    const credencialAcceso = urlParams.get('credencialAcceso');
    if (credencialAcceso) {
      // Si hay credencial, limpiar todo y NO restaurar sesión
      this.servicioEncriptar.limpiarStorage();
      this.variablesGlobales.empresaActual = null;
      this.variablesGlobales.usuarioActual = null;
      this.variablesGlobales.perfilAcceso = null;
      this.variablesGlobales.empresaAnterior = null;
      this.variablesGlobales.perfilAccesoAnterior = null;
      this.variablesGlobales.loginCorrecto = false;
      this.variablesGlobales.metodoAcceso = null;
      this.variablesGlobales.credencialAcceso = null;
      this.variablesGlobales.tabSeleccionadaHome = null;
      this.variablesGlobales.tipoOperacionDocumentoSeleccionada = null;
      this.variablesGlobales.sesionActual = null;
      // No restaurar nada más
      return;
    } else {
      this.servicioEncriptar.obtenerEnStorage('sesionActual')
        .then((res) => {
          if (res) {
            console.log("Datos después del refresh, ", res);
            const sesionActual: SesionActual = JSON.parse(res);

            if (sesionActual && sesionActual.metodoAcceso !== 'enlaceALO') {
              // Restaurar todas las propiedades
              this.variablesGlobales.sesionActual = sesionActual;
              this.variablesGlobales.usuarioActual = sesionActual.usuario;
              this.variablesGlobales.vendedorActual = sesionActual.vendedorActual;
              this.variablesGlobales.empresaActual = sesionActual.empresaActual;
              this.variablesGlobales.empresaAnterior = sesionActual.empresaActual;
              this.variablesGlobales.metodoAcceso = sesionActual.metodoAcceso;
              this.variablesGlobales.vistaGrid = sesionActual.vistaGrid;
              this.variablesGlobales.mostrarTabs = sesionActual.mostrarTabs;
              this.variablesGlobales.idiomaSeleccionado = sesionActual.idiomaSeleccionado;
              this.variablesGlobales.plataforma = sesionActual.plataforma;
              this.variablesGlobales.parametros = sesionActual.parametros;
              this.variablesGlobales.vendedores = sesionActual.vendedores;

              // Estas listas no se cargan directamente porque son muy grandes y pueden causar problemas de rendimiento
              // this.variablesGlobales.listaPedidosVenta = sesionActual.listaPedidosVenta || [];
              // this.variablesGlobales.listaPedidosCompra = sesionActual.listaPedidosCompra || [];
              // this.variablesGlobales.listaFacturasVenta = sesionActual.listaFacturasVenta || [];
              // this.variablesGlobales.listaFacturasCompra = sesionActual.listaFacturasCompra || [];
              // this.variablesGlobales.listaAlbaranesVenta = sesionActual.listaAlbaranesVenta || [];
              // this.variablesGlobales.listaAlbaranesCompra = sesionActual.listaAlbaranesCompra || [];
              // this.variablesGlobales.listaPresupuestos = sesionActual.listaPresupuestos || [];
              // this.variablesGlobales.listaArticulos = sesionActual.listaArticulos || [];
              // this.variablesGlobales.listaClientes = sesionActual.listaClientes || [];
              // this.variablesGlobales.listaClientesRecientes = sesionActual.listaClientesRecientes || [];
              // this.variablesGlobales.listaArticulosRecientes = sesionActual.listaArticulosRecientes || [];
              // this.variablesGlobales.listaProveedores = sesionActual.listaProveedores || [];
              // this.variablesGlobales.listaProveedoresRecientes = sesionActual.listaProveedoresRecientes || [];

              this.procesosGlobales.procesoPreCargaDatosStorage();

              // Información de pantalla y otros
              this.variablesGlobales.screenHeight = sesionActual.screenHeight;
              this.variablesGlobales.screenWidth = sesionActual.screenWidth;

              // Documento y estado
              this.variablesGlobales.documentoActual = sesionActual.documentoActual;
              this.variablesGlobales.documentoEnCurso = sesionActual.documentoEnCurso;

              // Perfiles y configuraciones
              this.variablesGlobales.perfilAcceso = sesionActual.perfilAcceso;
              this.variablesGlobales.perfilAccesoAnterior = sesionActual.perfilAccesoAnterior;
              this.variablesGlobales.tabSeleccionadaHome = sesionActual.tabSeleccionadaHome;
              this.variablesGlobales.margenSuperior = sesionActual.margenSuperior;

              // Datos de terceros y presupuestos
              this.variablesGlobales.presupuestosTercero = sesionActual.presupuestosTercero || [];
              this.variablesGlobales.presupuestosTerceroNumero = sesionActual.presupuestosTerceroNumero || 0;
              this.variablesGlobales.albaranesTercero = sesionActual.albaranesTercero || [];
              this.variablesGlobales.albaranesTerceroNumero = sesionActual.albaranesTerceroNumero || 0;
              this.variablesGlobales.facturasTercero = sesionActual.facturasTercero || [];
              this.variablesGlobales.facturasTerceroNumero = sesionActual.facturasTerceroNumero || 0;
              this.variablesGlobales.pedidosTercero = sesionActual.pedidosTercero || [];
              this.variablesGlobales.pedidosTerceroNumero = sesionActual.pedidosTerceroNumero || 0;

              // Artículos y configuraciones adicionales
              this.variablesGlobales.familiasArticulos = sesionActual.familiasArticulos || [];
              this.variablesGlobales.categoriasArticulos = sesionActual.categoriasArticulos || [];
              this.variablesGlobales.tiposTarifasPrecios = sesionActual.tiposTarifasPrecios || [];
              this.variablesGlobales.tiposTarifasPreciosCompra = sesionActual.tiposTarifasPreciosCompra || [];
              this.variablesGlobales.tiposTarifasDescuentos = sesionActual.tiposTarifasDescuentos || [];
              this.variablesGlobales.tiposIVA = sesionActual.tiposIVA || [];
              this.variablesGlobales.marcasArticulos = sesionActual.marcasArticulos || [];
              this.variablesGlobales.modelosArticulos = sesionActual.modelosArticulos || [];
              this.variablesGlobales.tiposRetencionServicios = sesionActual.tiposRetencionServicios || [];

              this.variablesGlobales.estadosPedidosALO = sesionActual.estadosPedidosALO || [];
              this.variablesGlobales.tipoOperacionDocumentoSeleccionada = sesionActual.tipoOperacionDocumentoSeleccionada;
              this.variablesGlobales.tipoTerceroSeleccionado = sesionActual.tipoTerceroSeleccionado;

              // Restaurar configuraciones
              globalConf.url_api_erp = sesionActual.urlApiErp;
              this.variablesGlobales.DecimalesEnMoneda = sesionActual.DecimalesEnMoneda;
              this.variablesGlobales.DecimalesEnUnidades = sesionActual.DecimalesEnUnidades;
              this.variablesGlobales.loginCorrecto = true;

              console.log('Sesión restaurada:', sesionActual);

              // Realiza cualquier acción necesaria tras restaurar
              this.procesosGlobales.obtenerParametrosAspecto();

              // Navega a la última URL
              this.router.navigateByUrl(sesionActual.urlActual);

              // Limpia el almacenamiento temporal
              this.servicioEncriptar.eliminarLocalStorage('sesionActual');
            }
          }
        })
        .catch((error) => {
          console.error('Error al recuperar sesión actual:', error);
        });
    }
    // Listener para cambios en el estado de la app
    App.addListener('appStateChange', async (state: AppState) => {
      console.log('App state changed. Is active?', state.isActive);
      this.variablesGlobales.appSegundoPlano = state.isActive;

      if (this.variablesGlobales.appSegundoPlano) {
        // VUELTA A LA APP DESDE SEGUNDO PLANO
      } else {
        // LA APP SE VA A SEGUNDO PLANO O SE VA A RECARGAR
        console.log("Ruta desde la que parte", this.router.url);

        if ((this.router.url != '/' && this.router.url != '/login') && this.variablesGlobales.loginCorrecto) {
          console.log("Url en la que estamos es distinta de la del login");

          if (this.interceptor.tokenValido()) {
            // Guardar los datos importantes de la sesión
            const sesionActual: SesionActual = {
              empresaActual: this.variablesGlobales.empresaActual,
              metodoAcceso: this.variablesGlobales.metodoAcceso,
              usuario: this.variablesGlobales.usuarioActual,
              vendedorActual: this.variablesGlobales.vendedorActual,
              urlActual: this.router.url,
              mostrarTabs: this.variablesGlobales.mostrarTabs,
              vistaGrid: this.variablesGlobales.vistaGrid,
              idiomaSeleccionado: this.variablesGlobales.idiomaSeleccionado,
              plataforma: this.variablesGlobales.plataforma,
              parametros: this.variablesGlobales.parametros,
              vendedores: this.variablesGlobales.vendedores,
              // listaPedidosVenta: this.variablesGlobales.listaPedidosVenta,
              // listaPedidosCompra: this.variablesGlobales.listaPedidosCompra,
              // listaFacturasVenta: this.variablesGlobales.listaFacturasVenta,
              // listaFacturasCompra: this.variablesGlobales.listaFacturasCompra,
              // listaAlbaranesVenta: this.variablesGlobales.listaAlbaranesVenta,
              // listaAlbaranesCompra: this.variablesGlobales.listaAlbaranesCompra,
              // listaPresupuestos: this.variablesGlobales.listaPresupuestos,
              // listaArticulos: this.variablesGlobales.listaArticulos,
              // listaClientes: this.variablesGlobales.listaClientes,
              // listaClientesRecientes: this.variablesGlobales.listaClientesRecientes,
              // listaArticulosRecientes: this.variablesGlobales.listaArticulosRecientes,
              // listaProveedores: this.variablesGlobales.listaProveedores,
              // listaProveedoresRecientes: this.variablesGlobales.listaProveedoresRecientes,
              screenHeight: this.variablesGlobales.screenHeight,
              screenWidth: this.variablesGlobales.screenWidth,
              documentoActual: this.variablesGlobales.documentoActual,
              documentoEnCurso: this.variablesGlobales.documentoEnCurso,
              perfilAcceso: this.variablesGlobales.perfilAcceso,
              perfilAccesoAnterior: this.variablesGlobales.perfilAccesoAnterior,
              tabSeleccionadaHome: this.variablesGlobales.tabSeleccionadaHome,
              margenSuperior: this.variablesGlobales.margenSuperior,
              presupuestosTercero: this.variablesGlobales.presupuestosTercero,
              presupuestosTerceroNumero: this.variablesGlobales.presupuestosTerceroNumero,
              albaranesTercero: this.variablesGlobales.albaranesTercero,
              albaranesTerceroNumero: this.variablesGlobales.albaranesTerceroNumero,
              facturasTercero: this.variablesGlobales.facturasTercero,
              facturasTerceroNumero: this.variablesGlobales.facturasTerceroNumero,
              pedidosTercero: this.variablesGlobales.pedidosTercero,
              pedidosTerceroNumero: this.variablesGlobales.pedidosTerceroNumero,
              familiasArticulos: this.variablesGlobales.familiasArticulos,
              categoriasArticulos: this.variablesGlobales.categoriasArticulos,
              tiposTarifasPrecios: this.variablesGlobales.tiposTarifasPrecios,
              tiposTarifasPreciosCompra: this.variablesGlobales.tiposTarifasPreciosCompra,
              tiposTarifasDescuentos: this.variablesGlobales.tiposTarifasDescuentos,
              tiposIVA: this.variablesGlobales.tiposIVA,
              marcasArticulos: this.variablesGlobales.marcasArticulos,
              modelosArticulos: this.variablesGlobales.modelosArticulos,
              tiposRetencionServicios: this.variablesGlobales.tiposRetencionServicios,
              estadosPedidosALO: this.variablesGlobales.estadosPedidosALO,
              tipoOperacionDocumentoSeleccionada: this.variablesGlobales.tipoOperacionDocumentoSeleccionada,
              tipoTerceroSeleccionado: this.variablesGlobales.tipoTerceroSeleccionado,
              urlApiErp: globalConf.url_api_erp,
              DecimalesEnUnidades: this.variablesGlobales.DecimalesEnUnidades,
              DecimalesEnMoneda: this.variablesGlobales.DecimalesEnMoneda,
            };

            await this.servicioEncriptar.guardarEnStorage("sesionActual", JSON.stringify(sesionActual));
            console.log('Sesión guardada');
          }
        }
      }
    });
  }


  controlarInternet() {
    Network.getStatus().then((res) => { this.variablesGlobales.conInternet = res.connected })
    Network.addListener('networkStatusChange', status => {
      console.log('Network status changed', status);
      this.variablesGlobales.conInternet = status.connected;
    });
  }

  seleccionadaTab(tabId: string) {
    this.variablesGlobales.tabSeleccionadaHome = tabId
    if (tabId == 'tabDocumentos') {
      this.variablesGlobales.tipoOperacionDocumentoSeleccionada = enumTipoOperacion.VENTA;
      this.router.navigate(['documentos'], { state: { segmentValue: enumSegmentTipoDocumento.PED, tipoOperacion: enumTipoOperacion.VENTA } })
    } else if (tabId == 'tabDocumentosCompra') {
      this.variablesGlobales.tipoOperacionDocumentoSeleccionada = enumTipoOperacion.COMPRA;
      this.router.navigate(['documentos-compra'], { state: { segmentValue: enumSegmentTipoDocumento.PED, tipoOperacion: enumTipoOperacion.COMPRA } })
    } else if (tabId == 'tabClientes') {
      this.variablesGlobales.tipoTerceroSeleccionado = eTipoFicheroTerceros.Cliente;
      this.router.navigate(['clientes'], { state: { tipoTercero: eTipoFicheroTerceros.Cliente } })
    } else if (tabId == 'tabProveedores') {
      this.variablesGlobales.tipoTerceroSeleccionado = eTipoFicheroTerceros.Proveedor;
      this.router.navigate(['proveedores'], { state: { tipoTercero: eTipoFicheroTerceros.Proveedor } })
    }
    //console.log('Seleccionada tab: ',this.selectTab);

  }

  esconderBarra() {
    let barra = Array.from(window.document.getElementsByClassName('headerBarraSuperior'));
    console.log();
    if (barra[0]) barra[0].setAttribute("style", "position: static")
  }

  mostrarBarra() {
    let barra = Array.from(window.document.getElementsByClassName('headerBarraSuperior'));
    console.log();
    if (barra[0]) barra[0].setAttribute("style", "position: 'fixed'")
  }

  obtenerIdiomaDispositivo() {
    Device.getLanguageCode().then((infoDevice) => {
      console.log('infoDevice', infoDevice);
      if (this.translate.getLangs().includes(infoDevice.value)) {
        this.translate.setDefaultLang(infoDevice.value);
        this.variablesGlobales.idiomaSeleccionado = (infoDevice.value)
      } else {
        console.log('El idioma del dispositivo no está en el grupo de idiomas que controlamos');

      }

    })

  }

  async cargarIdiomaStorage() {
    await this.servicioEncriptar.obtenerEnStorage('idiomaSeleccionado')
      .then((res: string) => {
        if (res) {
          console.log('Idioma almacenado: ', res);
          res = res.replace(/"/g, "");
          this.variablesGlobales.idiomaSeleccionado = res;
          this.translate.use(this.variablesGlobales.idiomaSeleccionado);
          if (res == 'es-ES' || res == 'eu-ES' || res == 'gl-ES') {
            this.variablesGlobales.localeMbs = localeEs
          } else if (res == 'ca-ES') {
            this.variablesGlobales.localeMbs = localeCa
          } else if (res == 'de-DE') {
            this.variablesGlobales.localeMbs = localeDe
          } else if (res == "en-US") {
            this.variablesGlobales.localeMbs = localeEn
          } else if (res == 'fr-FR') {
            this.variablesGlobales.localeMbs = localeFr
          } else if (res == 'it-IT') {
            this.variablesGlobales.localeMbs = localeIt
          } else if (res == 'pt-PT') {
            this.variablesGlobales.localeMbs = localePtPT
          } else if (res == 'uk-UA') {
            this.variablesGlobales.localeMbs = localeUa
          }

        } else {
          //No hay idioma almacenado, cogemos el idioma del dispositivos
          this.obtenerIdiomaDispositivo()
        }
      })
      .catch(error => {
        console.log('Error al recuperar idioma del storage', error);
        this.obtenerIdiomaDispositivo()

      })
  }

  obtenerPlataforma() {
    if ((this.platform.is('desktop') || this.platform.is('tablet') || this.isDescktopTactil())) {
      this.variablesGlobales.plataforma = 'desktop'
    } else {
      this.variablesGlobales.plataforma = 'movil'
    }

    console.log('Plataforma: ', this.variablesGlobales.plataforma);

    // Función para detectar si es un desktop o portátil con pantalla táctil


  }

  isDescktopTactil(): boolean {
    // Función para detectar si es un desktop o portátil con pantalla táctil

    const userAgent = navigator.userAgent.toLowerCase();
    const isWindows = userAgent.includes('windows');
    const isMac = userAgent.includes('macintosh');
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    // Consideramos desktop si es Windows o Mac y no es móvil
    // También incluimos portátiles con pantalla táctil en Windows
    return (isWindows || isMac) && (!this.platform.is('mobile') || isTouchDevice);

  }
  async seleccionadaPaginaMenuLateral(paginaUrl: string) {
    if (paginaUrl == 'home') {
      this.variablesGlobales.tabSeleccionadaHome = 'tabAgenda';
      this.router.navigateByUrl('home');

    } else if (paginaUrl == 'articulos') {
      this.variablesGlobales.tabSeleccionadaHome = 'tabArticulos';
      this.router.navigateByUrl('articulos');

    } else if (paginaUrl == 'clientes') {
      this.variablesGlobales.tabSeleccionadaHome = 'tabClientes';
      this.router.navigateByUrl('proveedores');
    } else if (paginaUrl == 'proveedores') {
      this.variablesGlobales.tabSeleccionadaHome = 'tabProveedores';
      this.router.navigateByUrl('clientes');

    } else if (paginaUrl == 'documentos') {
      this.variablesGlobales.tabSeleccionadaHome = 'tabDocumentos';
      this.router.navigateByUrl('documentos');
    } else if (paginaUrl == 'documentos-compra') {
      this.variablesGlobales.tabSeleccionadaHome = 'tabDocumentosCompra';
      this.router.navigateByUrl('documentos');

    }
    else if (paginaUrl == 'login') {
      console.log('Cerrar sesión!');
      this.variablesGlobales.mostrarTabs = false;
      this.variablesGlobales.usuarioActual = null;
      this.variablesGlobales.listaArticulos, this.variablesGlobales.listaArticulosRecientes = [];
      this.variablesGlobales.listaClientes, this.variablesGlobales.listaClientesRecientes = [];
      this.variablesGlobales.listaPresupuestos, this.variablesGlobales.listaProveedoresRecientes = []
      this.variablesGlobales.listaAlbaranesVenta, this.variablesGlobales.listaFacturasVenta, this.variablesGlobales.listaPedidosVenta, this.variablesGlobales.listaPresupuestos = [];

      this.variablesGlobales.empresaAnterior = null;
      this.variablesGlobales.perfilAccesoAnterior = null;
      this.variablesGlobales.loginCorrecto = false;
      this.variablesGlobales.empresaActual = null;
      this.variablesGlobales.vendedores = [];
      this.variablesGlobales.vendedorActual = null;
      this.variablesGlobales.peticionesPendientes = [];

      await Storage.clear()
      await db.resetDatabase()
      await Storage.set({
        key: 'recuerdameLogin',
        value: 'false'
      });
      this.variablesGlobales.recuerdameLogin = false
      window.location.reload();
      //this.router.navigateByUrl('login',{ replaceUrl: true,skipLocationChange: true  });
    }

  }

  // mostrarIconoHome(){
  //   if ((this.platform.width() > 768)) {
  // 		return true
  // 	} else {
  // 		return false;
  // 	}
  // }

  actualizarVersion() {
    if (!this.swUpdate.isEnabled) {
      console.log("SwUpdate not enbaled");
      return
    } else {
      console.log("SwUpdate enbaled");
    }
    this.swUpdate.checkForUpdate().then(() => console.log('Comprobada version PWA al abrir aplicacion'));
    let header: string;
    let message: string;
    let btnActualizar: string;
    this.swUpdate.versionUpdates.subscribe(async (event) => {
      if (event.type === 'VERSION_READY') {
        // Cargar textos traducidos
        await this.translate.get('toast.actualizarPWA.header').toPromise().then((resHeadesPWA: string) => {
          header = resHeadesPWA;
        });
        await this.translate.get('toast.actualizarPWA.mensaje').toPromise().then((resMessagePWA: string) => {
          message = resMessagePWA;
        });
        await this.translate.get('toast.actualizarPWA.botonActualizar').toPromise().then((resBtnActualizarPWA: string) => {
          btnActualizar = resBtnActualizarPWA;
        });

        // Mostrar toast solo si hay una nueva versión
        const toast = await this.toastController.create({
          header: header,
          message: message,
          position: 'bottom',
          color: 'warning',
          buttons: [
            {
              text: btnActualizar,
              handler: () => {
                this.swUpdate.activateUpdate().then(() => location.reload());
              }
            }
          ]
        });
        await toast.present();
      } else {
        console.log('No hay nueva versión disponible');
      }
    });

    // this.swUpdate.activated.subscribe((event)=>{
    //   console.log('current: ',event.previous, 'available: ',event.current)
    // })


  }

  async cargardocumentoActual() {
    await this.servicioEncriptar.obtenerEnStorage('documentoActual').then(resdocumentoActual => {
      if (resdocumentoActual) {
        //console.log('resdocumentoActual: ',resdocumentoActual);
        let documentoActual: DocumentoApp = JSON.parse(resdocumentoActual)
        this.variablesGlobales.documentoActual = documentoActual
        this.variablesGlobales.documentoEnCurso = true
        console.log('this.variablesGlobales.documentoActual: ', this.variablesGlobales.documentoActual);
      } else {
        console.log('No hay documento en el storage');
        this.variablesGlobales.documentoEnCurso = false
      }
    });
  }

  async obtenerInfoMeteorologica() {
    //Primero obtenemos la ubicación actual
    await this.verificacionesSvc.comprobarLocalizacionActivada()
      .then(async (res) => {
        if (res) {
          Geolocation.getCurrentPosition()
            .then(async (position) => {
              let latitud = position.coords.latitude;
              let longitud = position.coords.longitude;

              let url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=" + latitud + "," + longitud + "&location_type=GEOMETRIC_CENTER|ROOFTOP|GEOMETRIC_CENTER|APPROXIMATE&result_type=street_address|route|postal_code&key=AIzaSyAwIyX9pL25zOPNOV52gG76SbTAEz6sbKg"
              await this.httpClient.get(url, {}).toPromise()
                .then((res: any) => {
                  console.warn("Respuesta del servicio de geocoding:", res);
                  let direccion = JSON.parse(JSON.stringify(res.results[0]));
                  //console.log(direccion);
                  let ciudad = direccion.address_components.filter(dF => dF.types.includes('administrative_area_level_2'))[0].long_name;
                  this.httpClient.get('/assets/ProvinciasMunicipios/codigomunicipios.json').subscribe((listaMunicipios: []) => {
                    let infoMunicio: any = listaMunicipios.find((municipio: any) => municipio.NOMBRE == ciudad)
                    this.httpClient.get('/assets/ProvinciasMunicipios/codigoprovincias.json').subscribe((listaProvincias: []) => {
                      let infoProvincia: any = listaProvincias.find((provincia: any) => provincia.id == infoMunicio.CPRO)
                      //console.log('infoMunicio: ',infoMunicio);
                      //console.log('infoProvincia: ',infoProvincia);
                      this.meteoService.getUrlInfoAemet(infoProvincia.id, infoMunicio.CPRO + infoMunicio.CMUN).subscribe(res => {
                        this.variablesGlobales.prediccion = res;
                        this.ajustarArraysDiaActual();
                        //console.log('Res infoAemet: ',res);

                      }, error => {
                        console.error('Error al obtener la información meteorológica. ', error)
                        const toast = window.document.createElement('ion-toast');
                        toast.message = 'No se han podido obtener la información meteorológica.';
                        toast.duration = 4000;
                        toast.color = 'danger'
                        window.document.body.appendChild(toast);
                        toast.present();
                      })

                    })

                  })

                })
                .catch((err) => {
                  console.error("Error al hacer geocoding: ", err);
                })
            })
            .catch((err) => {
              console.error('Localización desactivada. ', err);

            })
        }
      })
  }

  ajustarArraysDiaActual() {
    let totalHoras = this.variablesGlobales.prediccion.pronostico.hoy.temperatura.length;
    this.variablesGlobales.prediccion.pronostico.hoy.estado_cielo = this.variablesGlobales.prediccion.pronostico.hoy.estado_cielo.slice(-totalHoras);
    this.variablesGlobales.prediccion.pronostico.hoy.humedad_relativa = this.variablesGlobales.prediccion.pronostico.hoy.humedad_relativa.slice(-totalHoras);
    this.variablesGlobales.prediccion.pronostico.hoy.nieve = this.variablesGlobales.prediccion.pronostico.hoy.nieve.slice(-totalHoras);
    this.variablesGlobales.prediccion.pronostico.hoy.precipitacion = this.variablesGlobales.prediccion.pronostico.hoy.precipitacion.slice(-totalHoras);
    this.variablesGlobales.prediccion.pronostico.hoy.racha_max = this.variablesGlobales.prediccion.pronostico.hoy.racha_max.slice(-totalHoras);
    this.variablesGlobales.prediccion.pronostico.hoy.sens_termica = this.variablesGlobales.prediccion.pronostico.hoy.sens_termica.slice(-totalHoras);
    this.variablesGlobales.prediccion.pronostico.hoy.viento = this.variablesGlobales.prediccion.pronostico.hoy.viento.slice(-totalHoras);
  }
  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.variablesGlobales.screenHeight = window.innerHeight;
    this.variablesGlobales.screenWidth = window.innerWidth;
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
      this.variablesGlobales.newColorScheme = event.matches ? "dark" : "light";
    });
    console.log('Screen Height: ', this.variablesGlobales.screenHeight);
    console.log('Screen Width: ', this.variablesGlobales.screenWidth);
  }

  ngAfterViewInit() {
    this.themeLinkElement = window.document.getElementById('theme') as HTMLLinkElement;
  }

  public changeTheme() {
    // Material Theme (6.1.0 is the version of the theme)
    this.themeLinkElement.href = 'https://kendo.cdn.telerik.com/themes/6.1.0/material/material-main-dark.css';
    console.log('Theme changed to Material', this.themeLinkElement.href);
  }



}
